import React from 'react'

const WaterfallChartComponent=(props)=> {
    console.log("===>WaterfallChartComponent props<===",props)
    return (
        <div>
           <b>Waterfall Chart</b> 
        </div>
    )
}

export default WaterfallChartComponent
